export const GEO_LINK_CLASS_NAME = 'geo-link';

export interface LinkifyOptions {
  className?: string | null;
  target?: string | { url: string };
}

export interface Coordinate {
  description: string;
  latitude: string | number;
  longitude: string | number;
}

export interface Matcher {
  regex: RegExp;
  matchCallback: (...args: string[]) => string;
}

export interface MatcherList {
  [key: string]: Matcher;
}
